import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import image1 from '../assets/gallery/image1.jpeg'
import image2 from '../assets/gallery/image2.jpeg'
import image3 from '../assets/gallery/image3.jpeg'
import image4 from '../assets/gallery/image4.jpeg'
import image5 from '../assets/gallery/image5.jpeg'
import image6 from '../assets/gallery/image6.jpeg'
import image7 from '../assets/gallery/image7.jpeg'
import image8 from '../assets/gallery/image8.jpeg'

const Gallery = () => {
    const navigate = useNavigate();
    const images = [image1, image2, image3, image4, image5, image6]
    const modalImages = [image1, image2, image3, image4, image5, image6, image7, image8]
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
    const handleResize = () => {
        setSize({
        width: window.innerWidth,
        height: window.innerHeight,
        });
    };

    window.addEventListener('resize', handleResize);

    // 컴포넌트 언마운트 시 이벤트 제거
    return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const openViewer = (index: number) => {
        setCurrentIndex(index);
        setIsOpen(true);
    };

    const closeViewer = () => setIsOpen(false);

    const prevImage = () => {
        setCurrentIndex((prev) => (prev === 0 ? modalImages.length - 1 : prev - 1));
    };

    const nextImage = () => {
        setCurrentIndex((prev) => (prev === modalImages.length - 1 ? 0 : prev + 1));
    };

    const goToGallery = () => {
        navigate('/pages/gallery')
    }

    const goToAbout = () => {
        navigate('/pages/about')
    }

    const goToContact = () => {
        navigate('/pages/contact')
    }

    return(
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", padding: "0px 8px",}}>
            {size.width > 768 && 
            <div style={{display: "flex", justifyContent: "center", gap: 32, marginBottom: 96}}>
                <div onClick={goToGallery} className="nav-item">GALLERY</div>
                <div onClick={goToAbout} className="nav-item">ABOUT</div>
                <div onClick={goToContact} className="nav-item">CONTACT</div>
            </div>}

            <div className="gallery">
                {images.map((src, i) => (
                    <img key={i} src={src} alt={`img-${i}`} onClick={() => openViewer(i)} />
                ))}
            </div>

            {/* 확대 모달 */}
            {isOpen && (
                <div className="modal" onClick={closeViewer}>
                <button className="close-btn" onClick={closeViewer}>×</button>
                <button className="nav-btn left" onClick={(e) => { e.stopPropagation(); prevImage(); }}>‹</button>
                <img
                    src={modalImages[currentIndex]}
                    alt="full-view"
                    className="modal-image"
                    onClick={(e) => e.stopPropagation()}
                />
                <button className="nav-btn right" onClick={(e) => { e.stopPropagation(); nextImage(); }}>›</button>
                </div>
            )}


            <div style={{width: "100%", height: 1, backgroundColor: '#E2E5E8', marginTop: 64,}} />
        </div>
    )
}

export default Gallery;